import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';

import FMPText from './pureForm/FMPText';
import { withStyles } from '@material-ui/core';
import withMobileDialog from '@material-ui/core/withMobileDialog/withMobileDialog';
import DialogContent from '@material-ui/core/DialogContent';
import FMPDatePicker from './pureForm/FMPDatePicker';
import FMPTimePicker from './pureForm/FMPTimePicker';
import Transition from './Dialogs/Transition';

const styles = (theme) => ({
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 30px 20px 30px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		maxWidth: '100%',
		width: 800,
		//maxWidth: '98%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	label: {
		paddingRight: 5,
	},
	value: {
		fontWeight: 600,
	},
	new: {
		marginTop: 20,
	},
	current: {
		marginBottom: 15,
	},
	addInputButton: {
		borderRadius: '100px',
	},
});

class AddDeliveryDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			deliveryAmount: '',
		};
	}

	componentDidUpdate(prevProps) {
		const { infoForDelivery, open } = this.props;

		if (open && prevProps.infoForDelivery !== infoForDelivery) {
			const { deliveryAmount, deliveryMoment } = infoForDelivery;

			const newState = {};
			if (deliveryAmount) {
				newState.deliveryAmount = deliveryAmount;
			} else {
				newState.deliveryAmount = '';
			}

			if (deliveryMoment) {
				newState.deliveryDate = deliveryMoment.format('YYYY-MM-DD');
				newState.deliveryTime = deliveryMoment.format('YYYY-MM-DD HH:mm');
			} else {
				newState.deliveryDate = '';
				newState.deliveryTime = '';
			}

			return this.setState(newState);
		}
	}

	handleRequestClose = () => {
		this.props.onClose();
	};

	handleAddUpdate = () => {
		const { infoForDelivery, showErrors, addDeliveryRecord, updateDeliveryRecord } = this.props;

		let { deliveryRecordId, station, tankNumber } = infoForDelivery;
		const { deliveryDate, deliveryTime, deliveryAmount } = this.state;

		if (!deliveryAmount) {
			return showErrors(['Volume is required']);
		}
		if (!deliveryDate || !deliveryTime) {
			return showErrors(['Delivery date / time is required']);
		}

		const deliveryMoment = moment(deliveryDate);
		const timeMoment = moment(deliveryTime);
		deliveryMoment.hour(timeMoment.hour()).minute(timeMoment.minute());

		const params = {
			stationId: station.stationId,
			tankNumber,
			adjustedDeliveryAmount: parseInt(deliveryAmount, 10),
			productType: 'e85',
			endDateTime: deliveryMoment.utc().format('YYYY-MM-DD HH:mm'),
		};

		if (deliveryRecordId) {
			params.deliveryRecordId = deliveryRecordId;
			updateDeliveryRecord({
				params,
				callback: function (err) {
					if (!err) {
						this.props.onClose();
					}
				}.bind(this),
			});
		} else {
			addDeliveryRecord({
				params,
				callback: function (err) {
					if (!err) {
						this.props.onClose();
					}
				}.bind(this),
			});
		}
	};

	onChange = (value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		this.setState(newState);
	};

	getInputProps = (path, defaultValue) => {
		return {
			path,
			value: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
			md: 12,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render() {
		const { infoForDelivery, classes } = this.props;
		if (!infoForDelivery) {
			return null;
		}
		const { deliveryRecordId, station, tankNumber, deliveryMoment } = infoForDelivery;

		if (!station) {
			return null;
		}

		const { number, name } = station;

		return (
			<Dialog
				classes={{ paper: classes.dialogPaper }}
				maxWidth="md"
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleRequestClose}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>Enter Delivery Amount</DialogTitle>

					<DialogContent style={{ fontSize: 18 }}>
						<div style={{ fontSize: 18 }}>
							Station :{' '}
							<strong>
								{number} - {name}
							</strong>
						</div>

						<div className={classes.current}>
							{tankNumber && (
								<div>
									<span className={classes.label}>Tank # : </span>
									<span className={classes.value}>{tankNumber}</span>
								</div>
							)}

							<div>
								<span className={classes.label}>Product : </span>
								<span className={classes.value}>E85</span>
							</div>

							{deliveryMoment && (
								<div>
									<span className={classes.label}>Delivery Date / Time : </span>
									<span className={classes.value}>{deliveryMoment.format('dddd, M/D h:mm a')}</span>
								</div>
							)}
						</div>

						<Grid container spacing={2}>
							<FMPDatePicker
								{...this.getInputProps('deliveryDate')}
								label={'Delivery Date'}
								md={6}
							/>

							<FMPTimePicker
								{...this.getInputProps('deliveryTime')}
								label={'Delivery Time'}
								md={6}
							/>
						</Grid>

						<FMPText {...this.getInputProps('deliveryAmount')} label={'Delivery Amount'} />
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleRequestClose}>Cancel</Button>
						<Button
							variant="contained"
							onClick={this.handleAddUpdate}
							color="primary"
							className={classes.addInputButton}
						>
							{deliveryRecordId ? 'Update Delivery' : 'Add Delivery'}
						</Button>
					</DialogActions>
				</div>
			</Dialog>
		);
	}
}

AddDeliveryDialog.propTypes = {
	open: PropTypes.bool,
	addDeliveryRecord: PropTypes.func.isRequired,
	updateDeliveryRecord: PropTypes.func.isRequired,

	infoForDelivery: PropTypes.object,

	onClose: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles), withMobileDialog()])(AddDeliveryDialog);
